import { createStyles } from "antd-style";

export const useModalSubscriptionAssignStyles = createStyles(
  ({ css }: any) => ({
    drawer: css`
      position: relative;
    `,
    loader: css`
      position: absolute;
      inset: 0;
      margin: auto;
    `,
    title: css`
      text-align: center;
    `,
    titleFreeLicenses: css`
      text-align: center;
    `,
    titleProductName: css``,
    businessUnitSelect: css``,
    businessUnitSelectItemDescription: css`
      font-weight: 400;
    `,
    businessUnitCreate: css``,
    vendorsSelect: css``,
    footerActions: css``,
  }),
);
